import React from 'react';
import { Observer } from 'mobx-react';
import { createUseStyles } from 'react-jss';
import { ThemeProps } from '@styles/theme';

import { SummaryPanel } from '@shared/components/SummaryPanel';
import { useGroupsUIStore, useUserPermissionsUIStore } from '@core/useStores';
import { USERS_IN_GROUP_ID } from '@shared/constants';

import UsersIcon from '@assets/users.svg';
import InstructorsIcon from '@assets/instructors.svg';
import ProceduresIcon from '@assets/procedures.svg';

import { messages } from '@shared/components/components.messages';
import { IUsersStatisticsStore, IBasePageQueryStore } from '@shared/stores';
import { useTheme } from '@mui/material/styles';

const useStyles = createUseStyles(() => ({
    panelWrapper: {
        marginBottom: 0,
        display: 'flex',
        justifyContent: 'center',
    },
}));

type UsersSummaryProps = {
    statistics: IUsersStatisticsStore,
    pageQueryStore: IBasePageQueryStore,
    className?: string,
};

export const UsersSummary: React.FC<UsersSummaryProps> = ({ statistics, pageQueryStore, className }) => {
    const theme = useTheme<ThemeProps>();
    const styles = useStyles({ theme });
    const groupsUIStore = useGroupsUIStore();
    const userPermissionsUIStore = useUserPermissionsUIStore();

    const renderValue = (value: number | null) => value === null ? '' : value;

    return (
        <Observer>
            {() => {
                const filters = pageQueryStore.getParams;
                const preparedData = [
                    {
                        id: 0,
                        title: messages['usersSummary.active.title'],
                        text: messages['usersSummary.active.text'](renderValue(statistics.usersCount)),
                        icon: UsersIcon,
                    },
                    {
                        id: 1,
                        title: messages['usersSummary.managed.title'],
                        text: messages['usersSummary.managed.text'](renderValue(statistics.instructorsCount)),
                        icon: InstructorsIcon,
                    },
                    {
                        id: 2,
                        title: messages['usersSummary.access.title'],
                        text: messages['usersSummary.access.text'](renderValue(statistics.proceduresCount)),
                        icon: ProceduresIcon,
                    },
                ];

                return (
                    <div className={styles.panelWrapper}>
                        <SummaryPanel
                            className={className}
                            items={preparedData}
                            hideTitle
                            isEditable={
                                userPermissionsUIStore.canUpdateGroup &&
                                (filters.inGroup === USERS_IN_GROUP_ID) && !!groupsUIStore.selectedGroup?.id
                            }
                            onEdit={() => groupsUIStore.showEditGroup(filters.inGroupId)}
                        />
                    </div>
                )
            }}
        </Observer>
    )
}
